import React from 'react';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from {
    transform: translate(-50%, 0) rotate(0deg);
  }

  to {
    transform: translate(-50%, 0) rotate(360deg);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const Spinner = styled.div`
  flex: 1;
  position: relative;

  &::after {
    animation: ${fadeIn} 0.25s ease-in 0.5s forwards, ${rotate} 0.75s linear infinite;
    border-radius: 50%;
    border: 3px solid GhostWhite;
    border-left: 3px solid Gray;
    content: '';
    opacity: 0;
    height: calc(1em + 3.5vw);
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: calc(1em + 3.5vw);
  }
`;



// WEBPACK FOOTER //
// ./src/components/Spinner.js